import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { useSession } from '@shared/hooks/useSession'

type optionsType = ReactQueryOptions['SocialManager']['isFollowing']
type inputType = RouterInputs['SocialManager']['isFollowing']

export const useIsFollowing = (input: inputType, options?: optionsType) => {
    const { status } = useSession()
    return api.SocialManager.isFollowing.useQuery(input, {
        ...options,
        queryKey: ['SocialManager.isFollowing', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        enabled: status === 'authenticated' && options?.enabled,
    })
}
